import React, { useState, useEffect } from 'react';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import '../../../assets/css/timeTable.css';
import Loader from "../../Shared/Loader/Loader";
import Toast from '../../Shared/Toast/Toast';
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { useNavigate } from 'react-router-dom';
import { useCatchResponse } from '../../../utils/useCatchResponse';

const ClassTimeTableCard = (props) => {
    const { catchResponse } = useCatchResponse();
    const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const [periodsList, setPeriodsList] = useState([]);
    const [isExpanded, setIsExpanded] = useState(false);
    const [timetableData, setTimetableData] = useState([]);
    const [duration, setDuration] = useState('');
    const [interval, setInterval] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        let resData = props?.ClassConfigurationData[0];
        setDuration(resData?.Duration);
        setInterval(resData?.Interval);
    }, []);

    const GetTimeTableData = async (classId) => {
        try {
            let data = {
                ClassId: classId,
            }
            Loader.show();
            const response = await api.post(APIConstant.path.GetTimeTableByClass, data);
            if (response?.success && response?.data.length > 0) {
                let periodData = response?.data[0]?.Periods?.map((x, idx) => {
                    return { Time: x?.Time, isBreak: x?.SubjectId === 'Break' ? true : false }
                });
                setPeriodsList(periodData);
                let timeTableData = response.data.map(row => {
                    if (row?.Duration) {
                        setDuration(row?.Duration);
                    }
                    if (row?.Interval) {
                        setInterval(row?.Interval);
                    }
                    const formattedRow = { Day: row?.Day, Id: row?.id };
                    row?.Periods?.forEach((period, index) => {
                        formattedRow[`Period${index + 1}`] = period?.SubjectId === 'Break' ? period?.SubjectId : period?.SubjectName;
                        formattedRow[`Teacher${index + 1}`] = period?.TeacherId === 'Break' ? period?.TeacherId : period?.TeacherName;
                    });
                    return formattedRow;
                });
                const sortedData = timeTableData.sort((a, b) => {
                    return days.indexOf(a?.Day) - days.indexOf(b?.Day);
                });
                setTimetableData(sortedData);
            } else {
                setPeriodsList([]);
                setTimetableData([]);
                Toast.error({ message: response?.message });
            }
            Loader.hide();
        } catch (error) {
            Loader.hide();
            console.error("Error fetching timetable:", error);
            catchResponse(error);
        }
    };

    const toggleExpand = (value) => {
        if (value) {
            GetTimeTableData(props?.ClassId);
        }
        setIsExpanded(value);
    };

    const printTimeTable = () => {
        try {
            Loader.show();
            const doc = new jsPDF();
            doc.setFontSize(16);
            doc.text(`Time Table for Class: ${props?.ClassName}`, 10, 10);

            const columns = [
                { header: "Days/Periods", dataKey: "Day" },
                ...periodsList.map((period, index) => ({
                    header: period?.Time,
                    dataKey: `Period${index + 1}`,
                })),
            ];

            const rows = timetableData.map((row) => {
                const formattedRow = { Day: row.Day };
                periodsList.forEach((_, index) => {
                    formattedRow[`Period${index + 1}`] = row[`Period${index + 1}`] === 'Break' ? row[`Teacher${index + 1}`] : `${row[`Period${index + 1}`]} - ${row[`Teacher${index + 1}`]}`;
                });
                return formattedRow;
            });

            autoTable(doc, {
                columns: columns,
                body: rows,
                startY: 20,
                theme: "grid",
            });
            Loader.hide();
            doc.save(`Class_Time_Table_${props?.ClassName || "Unknown"}.pdf`);
        } catch (error) {
            console.log('Error ');
            Loader.hide();
        }
    };

    return (
        <div className='time-table'>
            <div className="">
                <h2>{`Class : ${props?.ClassName}`}</h2>
                <div className="p-d-flex p-ai-center p-jc-between">
                    <div className="p-d-flex p-ai-center">
                        <div className='time-table-info'>
                            <h4 className='p-m-0'>Duration minute - </h4>
                            <p className='p-m-0 p-pl-1'>{duration}</p>
                        </div>
                        <div className='time-table-info p-ml-2' style={{ backgroundColor: '#EFEFEF' }}>
                            <h4 className='p-m-0'>Interval minute - </h4>
                            <p className='p-m-0 p-pl-1'> {interval}</p>
                        </div>
                    </div>
                    <div className="p-d-flex p-ai-center p-jc-between">
                        <Button icon="pi pi-pencil" className="e-sction-btn" onClick={() => navigate('/edit-class-time-table', { state: { ClassId: props?.ClassId } })} />
                        <Button icon="pi pi-print" className="e-sction-btn p-mx-2" onClick={async () => {
                            if (periodsList.length !== 0) {
                                await GetTimeTableData(props?.ClassId);
                            }
                            printTimeTable();
                        }} />
                        <Button
                            icon={`pi ${isExpanded ? 'pi-chevron-up' : 'pi-chevron-down'}`}
                            className="e-sction-btn"
                            onClick={() => toggleExpand(!isExpanded)}
                        />
                    </div>
                </div>
                {(isExpanded && periodsList.length !== 0) && (
                    <div className="p-mt-3">
                        <DataTable value={timetableData} responsiveLayout="scroll" className="custom-table" scrollHeight='min-content'>
                            <Column field="Day" header="Days/Periods" />
                            {periodsList?.map((period, index) => (
                                <Column
                                    key={index}
                                    field={`Period${index + 1}`}
                                    header={period?.Time}
                                    body={(rowData) =>
                                        rowData[`Period${index + 1}`] === 'Break' ? (
                                            rowData[`Period${index + 1}`]
                                        ) : (
                                            `${rowData[`Period${index + 1}`]} - ${rowData[`Teacher${index + 1}`]}`
                                        )
                                    }
                                />
                            ))}
                        </DataTable>
                    </div>
                )}

            </div>
        </div>
    );
};

export default ClassTimeTableCard;
